import { motion } from 'motion/react'

import { Text } from '@components/ui-core/text/text'

import type { Step } from '../../utils/steps'

import style from './title-and-text.module.scss'
export const TitleAndText = ({
  title,
  text,
  step,
  className,
  maxWidth = '500px',
  align = 'start',
}: {
  title: string
  text: string
  step?: Step
  maxWidth?: string
  className?: string
  align?: 'start' | 'center'
}) => {
  return (
    <div
      className={`${style.content} ${className}`}
      data-step={step}
      style={{ maxWidth, alignItems: align }}
    >
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Text className={style.title}>{title}</Text>
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Text as="span" className={style.text}>
          {text}
        </Text>
      </motion.p>
    </div>
  )
}
